import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";

import { fetchWrapper } from "_helpers";

//RTV MOCK DATA GET ALL
const res = {
  data: [
    {
      rtv_number: "RTV00001",
      rtv_sch_status: 1,
      pro_pickup_date: "2024-08-13",
      pro_pickup_time_from: "2024-08-13",
      pro_pickup_time_to: "2024-08-14",
      store_code: "100001",
      store_description: "Island Mart",
      store_short_description: "Island Mart",
      store_address1: "123 SM Megamall",
      store_address2: "EDSA corner Julia Vargas Avenue",
      store_address3: null,
      store_address4: null,
      store_city: "Mandaluyong City",
      store_zip: "1550",
      store_state: null,
      store_country: "Philippines",
      store_phone_num: "(02) 123-4567",
      store_fax_num: null,
      store_latitude: null,
      store_longitude: null,
      store_attr: null,
      created_at: null,
      updated_at: null,
    },
  ],
  success: true,
};
// create slice

const name = "schedulePickup";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  extraReducers,
});

// exports

export const schedulePickupAction = { ...slice.actions, ...extraActions };
export const pickupReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    list: {
      loading: true,
    },
    item: { loading: true },
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;

  return {
    getSchedulePickup: getSchedulePickup(),
  };

  function getSchedulePickup() {
    return createAsyncThunk(
      `${name}/rtvSchedule`,
      async (id) => await fetchWrapper.get(`${baseUrl}/rtv/rtvSchedule/${id}`)
    );
  }
}
function createExtraReducers() {
  return (builder) => {
    getSchedulePickup();
    function getSchedulePickup() {
      var { pending, fulfilled, rejected } = extraActions.getSchedulePickup;
      builder
        .addCase(pending, (state) => {
          state.item = { loading: true };
        })
        .addCase(rejected, (state, action) => {
          state.list = {};
          state.item = { loading: false };
        });
      // .addCase(rejected, (state, action) => {
      //   state.list = { error: action.error };
      // });
    }
    function getSchedulePickup() {
      var { pending, fulfilled, rejected } = extraActions.getSchedulePickup;
      builder
        .addCase(pending, (state) => {
          state.item = { loading: true };
        })
        .addCase(rejected, (state, action) => {
          state.item = { value: res };
        });
      // .addCase(rejected, (state, action) => {
      //   state.item = { error: action.error };
      // });
    }
  };
}
